import React from 'react';
import classnames from 'classnames';
import Mask from '@home/components/Mask';

import './index.scss';

import type { IBaseProps } from '@/pages/intelligence/types/common';

interface IInlineWatermarkProps extends IBaseProps {
  color?: string;
}

const InlineWatermark: React.FC<IInlineWatermarkProps> = (props) => {
  const { style, className, color = 'rgba(106, 109, 126, 0.3)' } = props;

  return (
    <div style={style} className={classnames('dbi-inline-watermask', className)}>
      <Mask color={color} />
    </div>
  );
};

export default InlineWatermark;
